mutation LogActivity($input: LogActivityInput!) {
    logActivity(input: $input) {
        activity {
            id
            activityType {
                id
                name
            }
        }
    }
}
